import { Registry as RegistryIcon, Shipping as ShippingIcon } from '@withjoy/joykit/icons';
import type { BadgeConfig, LineItemStatus } from './GiftBasketContent.types';
import { ReactComponent as OutlineCheckIcon } from '@assets/icons/outline-check.svg';
import { ReactComponent as CardCheckIcon } from '@assets/icons/card-check.svg';
import { ReactComponent as ProcessingIcon } from '@assets/icons/processing-icon.svg';
import { ReactComponent as ShippedIcon } from './assets/shipped-icon.svg';
import { ReactComponent as ZeroStateGiftListIcon } from './assets/zero-state-giftList-icon.svg';
import { ReactComponent as ZeroStateGiftTrackerIcon } from './assets/zero-state-giftTracker-icon.svg';

export const MAX_ITEM_COUNT = 24;
export const GIFT_TRACKER_CONFIG = {
  giftList: {
    FabBtnIcon: RegistryIcon,
    ZeroStateIcon: ZeroStateGiftListIcon,
  },
  giftTracker: {
    FabBtnIcon: ShippingIcon,
    ZeroStateIcon: ZeroStateGiftTrackerIcon,
  },
  checklist: {
    FabBtnIcon: null,
    ZeroStateIcon: null,
  },
  shoppingCart: {
    FabBtnIcon: null,
    ZeroStateIcon: null,
  },
} as const;

export const LINE_ITEM_STATUS_CONFIG: ReadonlyRecord<LineItemStatus, BadgeConfig> = {
  shipped: {
    color: 'green7',
    Icon: ShippedIcon,
  },
  processing: {
    color: 'purple7',
    Icon: ProcessingIcon,
  },
  given: {
    color: 'green7',
    Icon: OutlineCheckIcon,
  },
  purchased: {
    color: 'green7',
    Icon: OutlineCheckIcon,
  },
  reserved: {
    color: 'green7',
    Icon: CardCheckIcon,
  },
};
